import { ReactNode } from 'react'

interface PageContainerProps {
  children: ReactNode
  title?: string
  actions?: ReactNode
}

export function PageContainer({ children, title, actions }: PageContainerProps) {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {(title || actions) && (
        <div className="flex items-center justify-between mb-8">
          {title && <h1 className="text-2xl font-medium">{title}</h1>}
          {actions && <div className="flex items-center gap-3">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  )
}
